import { EmptyPaiDataArea } from '@upright/ui/common/upright/core/impact-lenses/pais/info-boxes/empty-data-area';
import { ImpactLensType } from '@upright/common/impact-lenses/types';
import { CarouselContext, useCarouselLayout } from '../../../impact-lens-profile/context';
import { usePaiLensContext } from '../common/use-pai-lens-context';
import { selectionStateToHighlightedImpact } from '../state';
import { PaiInfoBox } from './pai-info-box';

export function PaiInfoBoxes() {
  // TODO: support selection of other impact categories
  const context = usePaiLensContext();
  const layout = useCarouselLayout();
  if (context === undefined) {
    return <></>;
  }
  const boxMode = layout.boxMode;
  const selectionState = (context as CarouselContext<ImpactLensType.EU_PAIS>).selectionState;
  const impactToShow = selectionStateToHighlightedImpact(selectionState, boxMode);
  const hasPais = !!context.data.pais;

  return (
    <>
      {hasPais && impactToShow && <PaiInfoBox impact={impactToShow} />}
      <EmptyPaiDataArea />
    </>
  );
}
